<!-- Task Visibility Toggle - Toggle prive/public -->
<button
  type="button"
  class="task-visibility-toggle"
  [class.task-visibility-toggle--private]="isPrivate"
  [class.task-visibility-toggle--compact]="compact"
  [class.task-visibility-toggle--disabled]="disabled"
  [disabled]="disabled"
  [evaTooltip]="tooltipLabel"
  evaTooltipPosition="top"
  (click)="toggle()"
  tabindex="0"
>
  <i class="pi" [class.pi-lock]="isPrivate" [class.pi-lock-open]="!isPrivate"></i>
  <span *ngIf="!compact" class="task-visibility-toggle__label">{{ displayLabel }}</span>
</button>
